import {
  Badge,
  MessageBar,
  MessageBarBody,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from '@fluentui/react-components';
import { useApi } from '../api/useApi';
import { useAsync } from '../api/useAsync';
import { PageHeader } from '../components/PageHeader';
import { useSession } from '../auth/SessionProvider';

export function AuditLogPage() {
  const api = useApi();
  const { me } = useSession();
  const { data, loading, error } = useAsync(() => api.getAuditLog(), [api]);

  if (me && !me.isAdmin) {
    return (
      <div>
        <PageHeader title="Audit-Log" />
        <MessageBar intent="warning">
          <MessageBarBody>Für das Audit-Log sind Administratorrechte erforderlich.</MessageBarBody>
        </MessageBar>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Audit-Log" description="Wer hat wann was für welches Objekt gemacht." />
      {loading ? <Spinner label="Lade Audit-Log…" /> : null}
      {error ? (
        <MessageBar intent="error">
          <MessageBarBody>{error.message}</MessageBarBody>
        </MessageBar>
      ) : null}
      {data ? (
        <Table aria-label="Audit-Log" size="small">
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Zeitpunkt (UTC)</TableHeaderCell>
              <TableHeaderCell>Akteur</TableHeaderCell>
              <TableHeaderCell>Aktion</TableHeaderCell>
              <TableHeaderCell>Objekt</TableHeaderCell>
              <TableHeaderCell>Ticket</TableHeaderCell>
              <TableHeaderCell>Ergebnis</TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((e) => (
              <TableRow key={e.id}>
                <TableCell>{new Date(e.timestampUtc).toLocaleString('de-DE')}</TableCell>
                <TableCell>
                  <span className="pii">{e.actorUpn}</span>
                </TableCell>
                <TableCell>{e.action}</TableCell>
                <TableCell>
                  <span className="pii">{e.targetDisplay ?? e.targetId ?? '—'}</span>
                </TableCell>
                <TableCell>{e.ticketNumber ?? '—'}</TableCell>
                <TableCell>
                  <Badge appearance="tint" color={e.result === 'Success' ? 'success' : 'danger'}>
                    {e.result}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
            {data.length === 0 ? (
              <TableRow>
                <TableCell>Noch keine Einträge.</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      ) : null}
    </div>
  );
}
